import {Entity} from '../../../components/entity';
import {Category} from "../../category/state/model";
import {Product} from "../../../products/product/state/model";
import {Transporter} from "../../transporter/state/model";

export class Coupon extends Entity {
  amount: number;
  code: string;
  validFrom: Date;
  validTo: Date;
  isPercent: boolean;
  isActive: boolean;
  usableCount: number;
  name: string;
  minPrice: number;
  categories: Category[];
  products: Product[];
  freeShippingTransporter: Transporter;

  constructor({
                id,
                amount,
                code,
                validFrom,
                validTo,
                isPercent,
                isActive,
                usableCount,
                name,
                minPrice,
                categories,
                products,
                freeShippingTransporter,
                createdAt, updatedAt
              }: Partial<Coupon>) {
    super({id, createdAt, updatedAt});

    this.amount = amount ?? 0;
    this.code = code ?? '';
    this.validFrom = new Date(validFrom ?? '');
    this.validTo = new Date(validTo ?? '');
    this.isPercent = isPercent ?? false;
    this.isActive = isActive ?? false;
    this.usableCount = usableCount ?? 0;
    this.name = name ?? '';
    this.minPrice = minPrice ?? 0;

    this.categories = (categories ?? []).map(_item => new Category(_item ?? {}));
    this.products = (products ?? []).map(_item => new Product(_item ?? {}));
    this.freeShippingTransporter = new Transporter(freeShippingTransporter ?? {});
  }

  getNameProperty(): string {
    return 'slug';
  }
}
